require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./venir-en-semestre-dchange-2-5-1-0.json") })
        }
      }, "path---venir-en-semestre-dchange-2-5-1-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---venir-en-semestre-dchange-2-5-1-0!./.cache/json/venir-en-semestre-dchange-2-5-1-0.json
// module id = 598
// module chunks = 231608221292675